import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { shallow } from "zustand/shallow";

import NavigationButton from "../NavigationButton";
import Popover from "../Popover";
import ProposalClient from "../ProposalClient";
import ProposalList from "../ProposalList";

import useIntakeFormStore from "../../store/IntakeForm.store";

import "./proposal.scss";

const Proposal = () => {
  const [userSessionProposals, setUserSessionProposals] = useState(null);
  const [formOptions] = useIntakeFormStore(
    (state) => [state.data.formOptions, state.data.formState],
    shallow
  );

  const { id: proposalId } = useParams();

  useEffect(() => {
    if (formOptions?.sessionProposals.length > 0) {
      const sessionProposals = formOptions.sessionProposals.map((proposal) => {
        return {
          ...proposal,
          active: proposal.transitionId.toString() === proposalId,
        };
      });
      setUserSessionProposals(sessionProposals);
    }
  }, [formOptions, proposalId]);

  // client popover
  const [clientAnchorEl, setClientAnchorEl] = useState(null);
  const openClientPopover = Boolean(clientAnchorEl);
  const idClientPopover = openClientPopover ? "client-popover" : undefined;
  const handleClientClick = (event) => {
    setClientAnchorEl(event.currentTarget);
  };
  const handleClientClose = () => {
    setClientAnchorEl(null);
  };

  // proposals popover
  const [proposalsAnchorEl, setProposalsAnchorEl] = useState(null);
  const openProposalsPopover = Boolean(proposalsAnchorEl);
  const idProposalsPopover = openProposalsPopover
    ? "proposals-popover"
    : undefined;
  const handleProposalsClick = (event) => {
    setProposalsAnchorEl(event.currentTarget);
  };
  const handleProposalsClose = () => {
    setProposalsAnchorEl(null);
  };

  const proposalClient = <ProposalClient />;
  const proposals = (
    <ProposalList userSessionProposals={userSessionProposals} />
  );

  return (
    <div className="proposal">
      {proposalClient}

      <NavigationButton
        altLabel="Account Information"
        ariaLabel="Account Information"
        collapsible
        iconName="system-info"
        iconSize="small"
        onClick={handleClientClick}
        className="proposal__summary-alt"
      />

      {proposals}

      <NavigationButton
        altLabel="Proposals"
        ariaLabel="Proposals"
        collapsible
        iconName="system-list"
        iconSize="small"
        onClick={handleProposalsClick}
        className="proposal__list-alt"
      />

      <Popover
        id={idClientPopover}
        open={openClientPopover}
        anchorElement={clientAnchorEl}
        onClose={handleClientClose}
        anchorVertical="top"
        anchorHorizontal="right"
      >
        {proposalClient}
      </Popover>

      <Popover
        id={idProposalsPopover}
        open={openProposalsPopover}
        anchorElement={proposalsAnchorEl}
        onClose={handleProposalsClose}
        anchorVertical="top"
        anchorHorizontal="right"
      >
        {proposals}
      </Popover>
    </div>
  );
};

export default Proposal;
